import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { TextQuestion as TextQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  questionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  subtitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#616161',
    marginTop: '4px',
  },
  answerInput: {
    width: 'calc(100% - 30px)',
    minHeight: '32px',
    padding: '5px 8px',
    border: '1px solid #d1d1d1',
    borderRadius: '4px',
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#242424',
    backgroundColor: '#fafafa',
    resize: 'none',
    outline: 'none',
    marginLeft: '20px',
    '::placeholder': {
      color: '#616161',
    },
  },
  longAnswerInput: {
    minHeight: '100px',
  },
});

interface TextQuestionViewProps {
  question: TextQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const TextQuestionView: React.FC<TextQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.questionContainer} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} data-question-view>
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      {question.isLongAnswer ? (
        <textarea
          className={`${styles.answerInput} ${styles.longAnswerInput}`}
          placeholder="Enter your answer"
          readOnly
        />
      ) : (
        <input
          type="text"
          className={styles.answerInput}
          placeholder="Enter your answer"
          readOnly
        />
      )}
    </div>
  );
};
